import axios from 'axios'

// const rootUrl = 'https://localhost:44336/'
const rootUrl = process.env.REACT_APP_BASE_API_URL

export default axios.create({
  baseURL: rootUrl,
})
